@if (efecto?.spriteUrl && particulas.length) {
  <div class="tema-overlay" [class.contenido]="contenido">
    @for (p of particulas; track $index) {
      <img
        class="particula"
        [class.d0]="p.driftClass === 'd0'"
        [class.dl]="p.driftClass === 'dl'"
        [class.dr]="p.driftClass === 'dr'"
        [src]="efecto!.spriteUrl"
        [style.left.%]="p.left"
        [style.animation-delay.s]="p.delay"
        [style.animation-duration.s]="p.duration"
        [style.width.px]="p.size"
        [style.height.px]="p.size"
        alt=""
      />
    }
  </div>
}
